import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=520cb646&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"
import style0 from "./brand.vue?vue&type=style&index=0&id=520cb646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520cb646",
  null
  
)

export default component.exports